import React from 'react';
import { base } from '../helper/base-helper';
import { Link } from 'react-router-dom';
import { Divider, Button, Dropdown, Icon } from 'semantic-ui-react';

class ResultScrnButtons extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      notificationActive: false,
      loading: true
    };
  }

  componentWillMount() {
    const {user, action} = this.props;
    this.setNotiDBListener(user.uid, action.actionId);
  }

  componentWillUnmount() {
    if(this.ref)
    base.removeBinding(this.ref);
  }

  setNotiDBListener(uid, actionId) {
    this.ref = base.syncState(`_usernotifications/${uid}/${actionId}`, {
      context: this,
      state: 'notificationActive',
      then: () => this.setState({loading: false}),
      onFailure: err => console.error
    })
  };

  setNotification = (uid, actionId) => {
    const timestamp = Date.now();
    if(typeof this.state.notificationActive === 'number') {
      this.setState({notificationActive: null})
    } else {
      this.setState({notificationActive: timestamp})
    }
  }


  notifyClickHandler = (e) => {
    e.preventDefault();
    this.setNotification(this.props.user.uid, this.props.action.actionId)
    // this.setState({notificationActive: !this.state.notificationActive})
  }

  options = [
{ key: 'copy', icon: 'clipboard', text: 'Copy Link', value: 'copy' },
{ key: 'email', icon: 'mail', text: 'Email', value: 'email' },
{ key: 'slack', icon: 'slack', text: 'Slack', value: 'slack' },
{ key: 'twitter', icon: 'twitter', text: 'Twitter', value: 'twitter' },
]

  render() {
    // if(!this.state.loading)
    return (
      <Divider horizontal>
        <Button.Group labeled basic compact size='tiny'>
          <Button toggle icon='flag' content='Notify me' color='blue'
            active={typeof this.state.notificationActive === 'number'}
            onClick={this.notifyClickHandler} />
          <Dropdown options={this.options} button text='Share'/>
          <Button animated as={Link} to={`/${this.props.channel.url}`}>
            <Button.Content visible>More...</Button.Content>
            <Button.Content hidden>
              <Icon name='right arrow' />
            </Button.Content>
          </Button>
        </Button.Group>
      </Divider>
    );
  }

}

export default ResultScrnButtons;



// WEBPACK FOOTER //
// ./src/components/ResultScrnButtons.js